/* global Sys, Core */
Sys.ns("Core");

/**
 * The Settings Manager model.
 *
 * @class Core.SettingsManagerModel
 * @extends Core.Model
 */
Core.SettingsManagerModel = {

    constructor: function() {
        Core.SettingsManagerModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        this.data = {
            settings: {},
            lockedSettings: {},
            disabledSettings: {}
        };
    },

    /**
     * Checks if the setting is locked.
     *
     * @param {string} setting The setting name.
     * @returns {boolean} The setting state.
     */
    isLocked: function(setting) {
        var settingLock = this.readData("lockedSettings")[setting];

        return Sys.isArray(settingLock) && settingLock.length > 0;
    },

    /**
     * Checks if the setting is disabled.
     *
     * @param {string} setting The name of the setting.
     * @returns {boolean} The setting state.
     */
    isDisabled: function(setting) {
        return this.readData("disabledSettings")[setting];
    }
};

Core.SettingsManagerModel = Sys.extend(Core.Model, Core.SettingsManagerModel, "Core.SettingsManagerModel");
